<template>
  <div v-loading="loading" class="email-detail-page">
    <div class="left-panel">
      <div class="filter-bar">
        <el-select v-model="filter.sort" size="small" placeholder="排序" class="filter-select" @change="getEmailList(false)">
          <el-option label="日期" value="0" />
          <el-option label="发件人" value="1" />
        </el-select>
        <!--今天、昨天、一周内、上周、本月、上个月、今年、往年-->
        <el-select v-model="filter.searchDate" size="small" placeholder="日期" class="filter-select" @change="getEmailList(false)">
          <el-option label="全部" value="-1" />
          <el-option label="今天" value="0" />
          <el-option label="昨天" value="1" />
          <el-option label="一周内" value="2" />
          <el-option label="上周" value="3" />
          <el-option label="本月" value="4" />
          <el-option label="上个月" value="5" />
          <el-option label="今年" value="6" />
          <el-option label="往年" value="7" />
        </el-select>
        <el-input
          v-model="filter.keyword"
          size="small"
          placeholder="发件人/主题"
          class="filter-input"
          suffix-icon="el-icon-search"
          @keydown.enter.native="getEmailList(false)"
        />
      </div>
      <div class="email-list" @contextmenu.prevent @scroll="handleScroll">

        <el-empty v-if="isEmpty" style="width:100%" description="暂无邮件"></el-empty>
        <div v-for="group in emailList" :key="group.label" class="email-group">
          <div v-if="group.items.length>0" class="group-title" @click="toggleGroup(group)">
            <i class="el-icon-arrow-right group-arrow" :class="{ 'is-expanded': group.isExpanded }" />
            {{ group.label }}({{ group.items.length }}条)
          </div>
          <div v-show="group.isExpanded" v-if="group.items.length>0" class="group-content">
            <div
              v-for="email in group.items"
              :key="email.id"
              class="email-item"
              :class="{ active: selectedEmail && selectedEmail.id === email.id }"
              @click="selectEmail(email)"
              @contextmenu.prevent="showContextMenu($event, email)">
              <div class="email-item-left"><i :class="email.isStar?'el-icon-star-on':'el-icon-star-off'" @click="starEmail(email)" /> </div>
              <div class="email-item-right">
                <div class="item-subject" :class="email.isRead?'isRead':''">{{ email.subject }}</div>
                <div class="item-row">
                  <span class="item-sender">发件人：{{ email.sender.name || email.sender.address }}</span>
                  <span class="item-date">{{ email.receivedDate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-loading="isLoadingMore"></div>
      </div>
      <div class="left-footer">
        <el-button type="primary" size="small" class="compose-btn" @click="openCompose('compose')">
          <i class="el-icon-edit" /> 写邮件
        </el-button>
      </div>
    </div>

    <div v-if="selectedEmail" class="right-panel">
      <div class="detail-header">
        <h3 class="detail-title">{{ selectedEmail.subject }}</h3>
        <div class="detail-actions">
          <el-button v-if="currentEmail.folderName!='草稿箱' && currentEmail.folderName!='已发送'" size="small" icon="el-icon-chat-dot-square" @click="openCompose('reply', selectedEmail)">回复</el-button>
          <el-button v-if="currentEmail.folderName=='草稿箱'" size="small" icon="el-icon-position" @click="openCompose('draft', selectedEmail)">发送</el-button>
          <el-button size="small" icon="el-icon-delete" @click="deleteEmail">删除</el-button>
          <el-button v-if="currentEmail.folderName!='草稿箱' && currentEmail.folderName!='已发送'" size="small" icon="el-icon-position" @click="openCompose('forward', selectedEmail)">转发</el-button>
          <el-button v-if="currentEmail.folderName!='草稿箱' && currentEmail.folderName!='已发送'" size="small" icon="el-icon-refresh-left" @click="unRead">标为未读</el-button>
          <el-button v-if="currentEmail.folderName!='草稿箱' && currentEmail.folderName!='已发送'" size="small" :style="selectedEmail.isStar?'colir:#f2cb51;':''" :icon="selectedEmail.isStar?'el-icon-star-on':'el-icon-star-off'" @click="starEmail(selectedEmail)">{{ selectedEmail.isStar?'取消星标':'标为星标' }}</el-button>
        </div>
      </div>
      <div class="detail-info">
        <div class="info-row">
          <span class="info-label">发件人：</span>
          <span class="info-value">
            <template v-if="selectedEmail.sender.address != selectedEmail.sender.name">{{ selectedEmail.sender.name }}&lt;</template>{{ selectedEmail.sender.address }}<template v-if="selectedEmail.sender.address != selectedEmail.sender.name">&gt;</template>
          </span>
          <span class="info-label ml-20">发送时间：</span>
          <span class="info-value">{{ selectedEmail.receivedDate }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">收件人：</span>
          <span class="info-value">{{ selectedEmail.recipients.map(e => e.address).join('、') }}</span>
        </div>
        <div v-if="selectedEmail.cc && selectedEmail.cc.length" class="info-row">
          <span class="info-label">抄送：</span>
          <span class="info-value">{{ selectedEmail.cc.map(e => e.address).join('、') }}</span>
        </div>
        <div v-if="selectedEmail.attachments && selectedEmail.attachments.length" class="info-row attachments-row">
          <span class="info-label">附件：</span>
          <div class="attachment-list">
            <div v-for="(file, idx) in selectedEmail.attachments" :key="idx" class="attachment-tag" @click="downLoad(file)">
              <svg-icon v-if="file.fileName.split('.').pop().toLowerCase() == 'pdf'" iconClass="pdf" className="icon"></svg-icon>
              <svg-icon v-else-if="file.fileName.split('.').pop().toLowerCase() == 'xlsx'" iconClass="xlsx" className="icon"></svg-icon>
              <i v-else class="el-icon-document" />
              <span>{{ file.fileName }}</span>
              <i class="el-icon-download" />
            </div>
          </div>
        </div>
      </div>
      <div class="detail-body">
        <div class="detail-content">
          <iframe v-if="selectedEmail?.content" ref="emailFrame" class="email-frame"></iframe>
        </div>
        <div v-if="selectedEmail.inReplyToModels && selectedEmail.inReplyToModels.length" class="detail-inReplyTo-list">
          <div v-for="(reply, rIdx) in selectedEmail.inReplyToModels" :key="rIdx" class="detail-inReplyTo">
            <div class="detail-inReplyTo-header">
              <div>{{ reply.subject }}</div>
              <div>
                <div>发件人：<template v-if="reply.sender.address != reply.sender.name">{{ reply.sender.name }}&lt;</template>{{ reply.sender.address }}<template v-if="reply.sender.address != reply.sender.name">&gt;</template>
                </div>
                <div>发送时间：{{ reply.receivedDate }}</div>
              </div>
              <div>收件人：{{ reply.recipients.map(e => e.address).join('、') }}</div>
              <div v-if="reply.cc && reply.cc.length">抄送：{{ reply.cc.map(e => e.address).join('、') }}</div>
            </div>
            <div class="detail-inReplyTo-content" v-html="reply.content"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="right-panel empty">
      <div class="empty-text">请选择邮件查看详情</div>
    </div>

    <!-- 右键菜单 -->
    <ul
      v-show="contextMenu.visible"
      v-if="currentEmail.folderName!='草稿箱' && currentEmail.folderName!='已发送'"
      class="context-menu"
      :style="{ top: contextMenu.y + 'px', left: contextMenu.x + 'px' }"
    >
      <li @click="handleMenuAction('reply')">回复邮件</li>
      <li @click="handleMenuAction('forward')">转发邮件</li>
      <li @click="handleMenuAction('unread')">标为未读</li>
      <li @click="handleMenuAction('read')">标为已读</li>
      <li @click="handleMenuAction('delete')">删除邮件</li>
      <li class="has-sub">
        移动至
        <ul class="sub-menu">
          <li v-for="folder in folderList" :key="folder.id" @click="handleMenuAction('move', folder.id)">
            {{ folder.folderName }}
          </li>
        </ul>
      </li>
    </ul>

    <composeEmailDrawer
      :visible="composeVisible"
      :mode="composeMode"
      :email="composeEmail"
      @close="composeVisible = false"
      @sent="onEmailSent"
    />
  </div>
</template>

<script>

import { getEmailsByFolderId, getUserFolder, starEmail, readEmail, deleteEmail, moveEmail, getFolderById, downLoadEmailFile } from '@/api/email'
import { Empty } from 'element-ui'
import composeEmailDrawer from './components/composeEmailDrawer'
import SvgIcon from '../../components/icon/SvgIcon.vue'
export default {
  name: 'EmailDetail',
  components: {
      [Empty.name]: Empty,
      composeEmailDrawer,
      SvgIcon
  },
  data() {
    return {
      currentEmail: {},
      filter: {
        sort: '0',
        searchDate: '-1',
        keyword: ''
      },
      pageInput: {
        pageIndex: 1,
        pageSize: 300,
        totalCount: 0
      },
      selectedEmail: null,
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        email: null
      },
      folderList: [],
      emailList: [],
      loading: false,
      isLoadingMore: false,
      composeVisible: false,
      composeMode: 'compose',
      composeEmail: null,
      isEmpty: true
    }
  },
  computed: {
    folderId() {
      return this.$route.query.folderId
    }
  },
   watch: {
    // 监听路由参数变化
    '$route.query.folderId': {
      immediate: false,
      handler(newFolderId) {
        if (newFolderId) {
          this.getEmailList()
          this.getEmailFolder()
          this.getFolderById(newFolderId)
          this.selectedEmail = null
        }
      }
    }
   },
  created() {
    document.addEventListener('click', this.hideContextMenu)
    this.getEmailList()
    this.getEmailFolder()
    if (this.folderId) { this.getFolderById(this.folderId) }
    this.$root.$on('receiveEmail', this.handleReceiveEmail)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideContextMenu)
    this.$root.$off('receiveEmail', this.handleReceiveEmail)
  },
  methods: {
    async downLoad(file) {
      try {
        const res = await downLoadEmailFile({ guid: file.fileGuid })
        if (res) {
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = res
          elink.type = 'download'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    async deleteEmail() {
      this.$confirm('确认删除此邮件？此操作将不可逆!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
              await deleteEmail({ id: this.selectedEmail.id }).then(res => {
                if (res.success) {
                  this.selectedEmail = null
                  this.getEmailList()
                  this.$message.success('删除邮件成功')
                } else {
                  this.$message.error(res.errorMessage)
                }
              })
        }).catch(() => {})
    },
    async getFolderById(folderId) {
      await getFolderById({ folderId: folderId }).then(res => {
        if (res.success) {
          this.currentEmail = res.data
        }
      })
    },
    async starEmail(email) {
      await starEmail({ id: email.id, isStar: !email.isStar }).then(res => {
        if (res.success) {
          email.isStar = !email.isStar
          this.$message.success(`${email.isStar ? '' : '取消'}` + '星标邮件成功')
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    toggleGroup(group) {
      group.isExpanded = !group.isExpanded
    },
    async selectEmail(email) {
      this.selectedEmail = email

    // 使用iframe模仿沙箱环境 隔离email正文携带的样式污染系统
      await this.$nextTick() // 等 DOM 更新完成
      const frame = this.$refs.emailFrame
      if (!frame) return
      const doc = frame.contentDocument
      if (doc) {
        doc.open()
        doc.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <meta charset="utf-8">
              <style>
                body { margin: 0; padding: 20px; font-family: sans-serif; }
                * { max-width:100%; }
              </style>
            </head>
            <body style="width:97%;">${this.selectedEmail.content}</body>
          </html>
        `)
        doc.close()
      }

      if (email.isRead === false && this.currentEmail.folderName !== '草稿箱') {
        // 标记已读
        await readEmail({ id: email.id, isRead: true }).then(res => {
          if (res.success) {
            // 此时不刷新，没啥意义 直接标记已读就行
            email.isRead = true
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      }
    },
    unRead() {
      if (!this.selectedEmail || !this.selectedEmail.uniqueId) {
          this.$message.warning('请先选择一封邮件')
          return
      }
      this.$confirm('是否将当前邮件标记为未读状态？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
             // 标记未读
              await readEmail({ id: this.selectedEmail.id, isRead: false }).then(res => {
                if (res.success) {
                  // 此时不刷新，没啥意义 直接标记已读就行
                  this.selectedEmail.isRead = false
                  this.$message.success('已将邮件标记未读')
                } else {
                  this.$message.error(res.errorMessage)
                }
              })
        }).catch(() => {})
    },
    showContextMenu(e, email) {
      this.contextMenu = {
        visible: true,
        x: e.clientX,
        y: e.clientY,
        email
      }
    },
    hideContextMenu() {
      this.contextMenu.visible = false
    },
    handleMenuAction(action, folderId) {
      this.hideContextMenu()
      console.log('菜单操作：', action, folderId, this.contextMenu.email)

      if (action === 'reply' || action === 'forward' || action === 'draft') {
        const email = this.contextMenu.email || this.selectedEmail
        if (!email || Object.keys(email).length === 0) {
          this.$message.error('请先选择一封邮件')
          return
        }
        this.openCompose(action, email)
        return
      }

      if (!this.contextMenu.email || Object.keys(this.contextMenu.email).length === 0) {
        this.$message.error('请先选择一封邮件')
        return
      }

      if (action === 'move') {
        if (!folderId) {
          this.$message.error('文件夹Id异常为空，请联系管理员')
          return
        }
        moveEmail({ id: this.contextMenu.email.id, targetFolderId: folderId }).then(res => {
          if (res.success) {
            this.$message.success('邮件已移动')
            // 如果当前邮件选中了 则清空选中
            if (this.selectedEmail && this.selectedEmail.id === this.contextMenu.email.id) {
              this.selectedEmail = null
            }
            this.getEmailList()
          }
        })
      } else if (action === 'delete') {
        this.$confirm('确认删除此邮件？此操作将不可逆!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
              await deleteEmail({ id: this.contextMenu.email.id }).then(res => {
                if (res.success) {
                  if (this.selectedEmail && this.selectedEmail.id === this.contextMenu.email.id) {
                    this.selectedEmail = null
                  }
                  this.getEmailList()
                  this.$message.success('删除邮件成功')
                } else {
                  this.$message.error(res.errorMessage)
                }
              })
        }).catch(() => {})
      } else if (action === 'read' || action === 'unread') {
        const isRead = action === 'read'
        if (this.contextMenu.email.isRead === isRead) {
          this.$message.warning('当前邮件已是' + (isRead ? '已读' : '未读') + '')
          return
        }
        this.$confirm('是否将当前邮件标记为' + (isRead ? '已读' : '未读') + '状态？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
            // 标记
            await readEmail({ id: this.contextMenu.email.id, isRead: isRead }).then(res => {
              if (res.success) {
                // 此时不刷新，没啥意义 直接标记已读就行
                this.contextMenu.email.isRead = isRead
                this.$message.success('已将邮件标记' + (isRead ? '已读' : '未读') + '')
              } else {
                this.$message.error(res.errorMessage)
              }
            })
        }).catch(() => {})
      }
    },
    openCompose(mode, email) {
      this.composeMode = mode
      this.composeEmail = email || null
      console.log(email)
      this.composeVisible = true
    },
    onEmailSent() {
      if (this.selectedEmail && this.currentEmail.folderName === '草稿箱') {
        this.selectedEmail = null
      }
      // 发送成功后刷新列表
      this.getEmailList()
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.loadMore()
      }
    },
    loadMore() {
      if (this.isLoadingMore) return
      const maxPage = Math.ceil(this.pageInput.totalCount / this.pageInput.pageSize)
      if (this.pageInput.pageIndex >= maxPage) return
      this.isLoadingMore = true
      this.pageInput.pageIndex++
      this.getEmailList(true).finally(() => {
        this.isLoadingMore = false
      })
    },
    async getEmailFolder() {
      await getUserFolder({ hasSystemFolder: false }).then(res => {
        if (res.success && res.data && res.data.length > 0) {
          this.folderList = res.data.filter(folder => folder.id !== this.folderId)
        }
      })
    },
    handleReceiveEmail(message) {
      this.getEmailList()
      // console.log('receiveEmail', message)
      const msg = JSON.parse(message)
      if (msg.message && msg.message !== '没有新邮件需要处理') {
        this.$message.success(msg.message)
      }
    },
    async getEmailList(isAppend = false) {
      if (!isAppend) {
        this.pageInput.pageIndex = 1
        this.loading = true
      }
      const params = {
        pageIndex: this.pageInput.pageIndex,
        pageSize: this.pageInput.pageSize,
        queryParam: {
          folderId: this.folderId,
          search: this.filter.keyword === '' ? undefined : this.filter.keyword,
          searchDate: this.filter.searchDate === '-1' ? undefined : this.filter.searchDate,
          sortBy: this.filter.sort
        }
      }
      await getEmailsByFolderId(params).then(res => {
        if (res.success) {
          const list = res.data.list || []
          this.isEmpty = list.every(group => !group.items || group.items.length === 0)
          this.pageInput.totalCount = res.data.total || 0
          if (isAppend) {
            // 分组合并
            const groupMap = new Map(this.emailList.map(g => [g.label, g]))
            list.forEach(newGroup => {
              if (groupMap.has(newGroup.label)) {
                const existingGroup = groupMap.get(newGroup.label)
                existingGroup.items.push(...newGroup.items)
              } else {
                this.emailList.push(newGroup)
              }
            })
          } else {
            this.emailList = list
          }
        } else {
          this.$message.error(res.errorMessage)
        }

        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.email-frame {
  width: 100%;
  height: 98.5%;
  border:none;
}
.email-detail-page {
  display: flex;
  height: calc(100% - 15px);
  width: calc(100% - 15px);
  overflow: hidden;
  margin-left: 10px;
}
.left-panel {
  width: 320px;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.filter-bar {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #e8e8e8;
  gap: 8px;
  .filter-select {
    width: 80px;
  }
  .filter-input {
    flex: 1;
  }
}
.email-list {
  flex: 1;
  overflow-y: auto;

  /* 滚动条样式 */
  &::-webkit-scrollbar {
    height: 6px;
    width: 0;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 3px;
    transition: background-color 0.2s ease;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: transparent;
    cursor: pointer;
  }

}
.email-group {
  .group-title {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    font-size: 12px;
    color: #999;
    border-bottom:1px solid #f6f6f6;
    background: #fafafa;
    cursor: pointer;
    user-select: none;
    .group-arrow {
      margin-right: 6px;
      font-size: 12px;
      transition: transform 0.2s;
      color: #999;
    }
    .group-arrow.is-expanded {
      transform: rotate(90deg);
    }
  }
  .group-content {
    transition: all 0.2s;
  }
}
.email-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  &:hover, &.active {
    background: #f1f6fc;
  }
  .email-item-left{
    margin-top: 5px;
  }
  .email-item-left i{
    font-size: 15px;
    color: #cccccc;
  }
  .email-item-left i:hover{
    color: #f2cb51;
  }
  .email-item-left i.el-icon-star-on{
    font-size: 19px;
    color: #f2cb51;
    margin-left: -3px;
  }
  .email-item-right{
    flex: 1;
    margin-left: 5px;
    overflow: hidden;
  }
  .item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
  }
  .item-sender {
    font-size: 11px;
    color: #999;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 180px;
  }
  .item-date {
    font-size: 11px;
    color: #999;
    flex-shrink: 0;
  }
  .item-subject {
    font-size: 12px;
    color: #333;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.isRead{
      color: #999;
    }
  }
}
.left-footer {
  padding: 10px;
  border-top: 1px solid #e8e8e8;
  text-align: center;
  .compose-btn {
    width: 100%;
  }
}
.right-panel {
  margin-left: 5px;
  background: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  &.empty {
    align-items: center;
    justify-content: center;
    .empty-text {
      color: #999;
      font-size: 14px;
    }
  }
}
.detail-header {
  padding: 16px 20px;
  // border-bottom: 1px solid #e8e8e8;
  display: flex;
  .detail-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
    flex: 1;
  }
}
.detail-info {
  padding: 12px 20px;
  border-bottom: 1px solid #e8e8e8;
  font-size: 13px;
  .info-row {
    margin-bottom: 6px;
    display: flex;
    align-items: flex-start;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .info-label {
    color: #333;
    flex-shrink: 0;
    &.ml-20 {
      margin-left: 20px;
    }
  }
  .info-value {
    color: #666;
    font-size: 12px;
  }
  .attachments-row {
    align-items: center;
  }
  .attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .attachment-tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 3px 8px;
      background: #f9f9f9;
      border-radius: 4px;
      font-size: 12px;
      color: #666;
      cursor: pointer;
      .el-icon-download {
        color: #1890ff;
        cursor: pointer;
      }
    }
  }
}

.detail-body {
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /deep/ p {
    margin: 0 0 10px 0;
  }

  .detail-content{
    flex: 1;
  }

  @keyframes identifier {
    to{
      transform: translate(0);
      opacity: 1;
    }
  }

  .detail-inReplyTo-list{
    flex-shrink: 0;
    max-height: 50%;
    overflow-y: auto;
    border-top: 1px solid #e8e8e8;
    padding: 10px;

    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: #bbb;
    }
  }

  .detail-inReplyTo{
    padding: 10px;
    font-size: 12px;
    background: #fafafa;
    border-radius: 5px;
    margin-bottom: 10px;
    opacity: 0;
    transition: 0.2s ease-in-out;
    transform: translateY(-15px) ;
    animation:  identifier 0.1s ease-in forwards;

    &:last-child {
      margin-bottom: 0;
    }

    .detail-inReplyTo-header{
      color: #666;

      >div:first-child{
        color:#333;
        font-size: 13px;
      }

      > div:nth-last-of-type(2){
        display: flex;
        margin-top: 10px;

        >div:first-child{
          margin-right: 20px;
        }
      }
    }
    .detail-inReplyTo-content{
      margin-top: 10px;
      padding-top: 20px;
      border-top: #f0f0f0 solid 1px;
    }

  }
}
.context-menu {
  position: fixed;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 9999;
  list-style: none;
  padding: 4px 0;
  margin: 0;
  min-width: 120px;
  li {
    padding: 6px 12px;
    font-size: 13px;
    color: #333;
    cursor: pointer;
    &:hover {
      background: #e6f7ff;
      color: #1890ff;
    }
  }
  .has-sub {
    position: relative;
    .sub-menu {
      display: none;
      position: absolute;
      left: 100%;
      top: 0;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      list-style: none;
      padding: 4px 0;
      margin: 0;
      min-width: 100px;
    }
    &:hover .sub-menu {
      display: block;
    }
  }
}

button .el-icon-star-on{
    color: #f2cb51 !important;
}

</style>
